import { EnumAPPRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/EnumAPPRelationshipType';
import { TaskSequence } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/TaskSequence';

export class TaskSequenceExtend {
  public static Init(dto: TaskSequence) {
    dto.aPPRelationshipType = EnumAPPRelationshipType.TaskSequence;
  }
}
